'use strict';

import StoriesView from './stories.view.ctrl';
// import StoriesList from './stories.list.ctrl';

export default angular
  .module('main.stories', [
    StoriesView,
    // StoriesList
  ])
  .name;
